import { RoleType } from '@tool-no-hu/shared/enums';
import api from '../lib/api';

export interface User {
  id: string;
  username: string;
  name: string;
  role: RoleType;
}


export async function loginService(username: string, password: string): Promise<User | null> {
  try {
    const response = await api.post('/api/v1/auths/login', {
      username,
      password,
    });

    if (response.data && response.data.code === 200) {
      const { user } = response.data.data;

      // Token chỉ tồn tại trong cookie httpOnly do BE set — FE không cần
      // (và không nên) đọc/lưu token trực tiếp.

      // Map backend role name to frontend UserRole
      const backendRoleName = typeof user.role === 'object' ? user.role.name : '';
      let mappedRole: RoleType = RoleType.USER;
      if (backendRoleName === RoleType.ADMIN) {
        mappedRole = RoleType.ADMIN;
      }

      return {
        id: user._id,
        username: user.username,
        name: user.username, // Default name to username
        role: mappedRole,
      };
    }
    return null;
  } catch (error) {
    console.error('Login service API error:', error);
    return null;
  }
}
